import React from 'react';
import ErrorFilled from './icons/ErrorFilled';

type BannerProps = {
  zip: string;
  openCallback: Function;
};

export default function DeliveryBanner(props: BannerProps) {
  const { zip, openCallback } = props;

  return (
    <div
      data-package="geolocation"
      data-qa="delivery-banner"
      data-testid="delivery-banner"
    >
      <div className="align-center flex max-w-full justify-center bg-grey-1 py-[14px] text-base md:py-[18px]">
        <ErrorFilled />
        <div className="px-8 font-sans text-blue-6 tl-header-xs md:tl-header-s">
          Delivery unavailable for {zip}
        </div>
        <div
          className="cursor-pointer font-sans text-blue-2 tl-header-xs hover:text-blue-3 md:tl-header-s"
          tabIndex={0}
          onClick={() => {
            openCallback(true);
          }}
          onKeyUp={e => e.key === 'Enter' && openCallback(true)}
          data-analytics-id="Delivery Banner - Change Location"
        >
          Change Location
        </div>
      </div>
    </div>
  );
}
